module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-stone-path-remnants.72aa5679.png";